import { CSSProperties } from 'react';

const ROLE_COLOR_PALETTE: Array<{ backgroundColor: string; borderColor: string }> = [
  { backgroundColor: '#F7F9FF', borderColor: 'var(--blue)' },
  { backgroundColor: '#F7FBF9', borderColor: 'var(--green)' },
  { backgroundColor: '#FFFDF5', borderColor: 'var(--yellow-dark)' },
  { backgroundColor: '#FFF8F8', borderColor: 'var(--red)' },
  { backgroundColor: '#FAFCF5', borderColor: 'var(--grass)' },
  { backgroundColor: '#FFF8FC', borderColor: 'var(--pink)' },
  { backgroundColor: '#FFF9F5', borderColor: 'var(--orange)' },
  { backgroundColor: '#FAF9FF', borderColor: 'var(--violet)' },
  { backgroundColor: '#F6FCFF', borderColor: 'var(--sky-blue)' },
  { backgroundColor: '#FBF8FF', borderColor: 'var(--magenta)' },
];

const roleColorIndexMap = new Map<string, number>();

const hashRole = (role: string): number => {
  let hash = 0;
  const normalizedRole = role.trim().toLowerCase();

  for (let i = 0; i < normalizedRole.length; i++) {
    hash = (hash * 31 + normalizedRole.charCodeAt(i)) >>> 0;
  }

  return hash;
};

export const getRoleChipStyle = (role: string): CSSProperties => {
  const normalizedRole = role.trim().toLowerCase();
  const existingColorIndex = roleColorIndexMap.get(normalizedRole);

  if (existingColorIndex !== undefined) {
    const existingColor = ROLE_COLOR_PALETTE[existingColorIndex];
    return {
      backgroundColor: existingColor.backgroundColor,
      color: 'var(--black)',
      border: `1px solid ${existingColor.borderColor}`,
      fontWeight: 500,
    };
  }

  const preferredColorIndex = hashRole(normalizedRole) % ROLE_COLOR_PALETTE.length;
  const usedColorIndexes = new Set(roleColorIndexMap.values());

  let colorIndex = preferredColorIndex;
  if (usedColorIndexes.size < ROLE_COLOR_PALETTE.length) {
    while (usedColorIndexes.has(colorIndex)) {
      colorIndex = (colorIndex + 1) % ROLE_COLOR_PALETTE.length;
    }
  }

  roleColorIndexMap.set(normalizedRole, colorIndex);
  const color = ROLE_COLOR_PALETTE[colorIndex];

  return {
    backgroundColor: color.backgroundColor,
    color: 'var(--black)',
    border: `1px solid ${color.borderColor}`,
    fontWeight: 500,
  };
};
